export const PROJECT_NAME = "Hanab Live";
export const DOMAIN = "hanab.live";
export const OLD_DOMAIN = "hanabi.live";
const PROTOCOL = "https";
export const SITE_URL = `${PROTOCOL}://${DOMAIN}`;
